/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { NavLink } from 'react-router-dom';
import AuthenticationButton from '../common/auth/AuthenticationButton';
import { RoutePaths } from '../../Constants/Common';
import { useAuth0 } from '@auth0/auth0-react';
import './NavBar.scss';
import { useAppSelector } from 'state/hooks';
import { CultureSettingsComponent } from './CultureSettingsComponent';

const NavBar = (): JSX.Element => {
    const brandId = useAppSelector((s) => s.site.brandId);
    const { isAuthenticated } = useAuth0();
    const features = useAppSelector((s) => s.site.features);

    return (
        <nav className='navbar navbar-expand-lg nav-bar-container'>
            <div className='container-fluid'>
                <NavLink to={RoutePaths.LandingPage} className='navbar-brand'>
                    <img
                        src={require(`../../images/${brandId}/brand_logo.png`)}
                        height='35'
                        alt='logo'
                    />
                </NavLink>
                <button
                    className='navbar-toggler'
                    type='button'
                    data-toggle='collapse'
                    data-target='#navbarNav'
                    aria-controls='navbarNav'
                    aria-expanded='false'
                    aria-label='Toggle navigation'>
                    <span className='navbar-toggler-icon'></span>
                </button>
                <div className='right-align-navbar-item d-flex align-items-center gap-3'>
                    {!!features.LanguageSwitch && <CultureSettingsComponent />}
                    {isAuthenticated && (
                        <div>
                            <AuthenticationButton />
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default NavBar;
